import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {SenderService} from '../../../../services/sender.service';
import {TelegramService} from '../../../../pages/page-telegram/telegram.service';
import {AppService} from '../../../../services/app.service';
import {log} from '../../../../functions';
import {debounceTime} from 'rxjs/operators';
import {InterfaceService} from '../../../../services/interface.service';
import {AllMessengersService} from '../../../../pages/page-start/all-messengers.service';
import {ModalService} from '../../../../services/modal.service';

@Component({
  selector: 'app-add-form-chat-step',
  templateUrl: './add-form-chat-step.component.html',
  styleUrls: ['./add-form-chat-step.component.scss']
})
export class AddFormChatStepComponent implements OnInit {
  helpTypeOnlyDownload = '';
  helpTypeSndSend = '';

  constructor(
    public modalService: ModalService,
    public allMessengersService: AllMessengersService,
    public telegramService: TelegramService,
    public senderService: SenderService,
    public interfaceService: InterfaceService,
    private cd: ChangeDetectorRef,
    public appService: AppService
  ) { }

  ngOnInit(): void {
    this.senderService.senderForm.get('parsed_chat').valueChanges.pipe(debounceTime(1000)).subscribe((v) => {
      if (v?.length < 3) { return; }
      log('getDetailInfo', v);
      delete this.senderService.chatInfo;
      delete this.senderService.errorChatDetail;
      this.senderService.loadedChatDetail = false;
      this.cd.detectChanges();
      const clearContact = this.telegramService.clearContact(v);
      const telegramService = (this.allMessengersService.getServicesFilter('isAuth', true)
        .find((Service) => Service instanceof TelegramService) as TelegramService);

      telegramService.getDetailInfo(clearContact, false, 1, true).subscribe((res) => {
        this.senderService.chatInfo = res;
        this.senderService.loadedChatDetail = true;
        this.cd.detectChanges();
      }, error => {
        delete this.senderService.chatInfo;
        delete this.senderService.errorChatDetail;
        // TODO отключил потому что часто лагало
        if (error?.status === 404 || error?.status === 403) {
          this.senderService.errorChatDetail = this.interfaceService.errorHandling(error, false);
        }
        this.senderService.loadedChatDetail = true;
        this.cd.detectChanges();
      });
    });
  }

  setTypeChange(type: number): void {
    this.senderService.setSenderTypes$.next();
  }
}
